<ng-container *ngIf="showSplashScreen">
  <app-splash-screen message="Authenticating"></app-splash-screen>
</ng-container>
<ng-container *ngIf="!showSplashScreen">
  <app-global-spinner [show]="showGlobalLoadingSpinner"></app-global-spinner>
  <app-header *ngIf="userService.loggedInUser"></app-header>
  <div class="content">
    <app-breadcrumb></app-breadcrumb>
    <router-outlet></router-outlet>
  </div>

  <app-footer *ngIf="userService.loggedInUser" class="footer"></app-footer>
</ng-container>